module.exports = __webpack_public_path__ + "static/img/impressao_recibo.dd36ebe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/impressao_recibo.jpg
// module id = KA3G
// module chunks = 1